import type { AvailableQuantityItem } from './types';

export const getStoreAvailableQuantity = (
  storeId: number,
  availableQuantity?: AvailableQuantityItem[]
): number | null => {
  if (!availableQuantity?.length) return null;
  const found = availableQuantity.find(item => item.store_id === storeId);
  return found ? found.amount : null;
};

export const escapeRegex = (value: string): string =>
  value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
